module.exports = __webpack_public_path__ + "img/Recurso 59@300x.5223e59e.png";